import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './index.css'
import App from "./App";
import {DivisonProvider} from "./context/DivisonContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <DivisonProvider>
          <App></App>
      </DivisonProvider>
  </React.StrictMode>
);


reportWebVitals();
